import React from 'react';

interface ClientVisitConfirmationProps {
  formData: any;
  onSubmit: () => void;
  onBack: () => void;
  loading: boolean;
}

export const ClientVisitConfirmation: React.FC<ClientVisitConfirmationProps> = ({
  formData, onSubmit, onBack, loading
}) => {
  return (
    <div className="p-6 sm:p-8 space-y-6 overflow-y-auto flex-grow">
      <div className="bg-sky-50/80 p-5 rounded-3xl border border-sky-100 space-y-4">
        <h4 className="text-xs font-black text-sky-900 uppercase border-b border-sky-200/80 pb-2 tracking-wider">
          Resumen de tu Solicitud
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
          <div><p className="text-[9px] font-black text-gray-400 uppercase">Cliente</p><p className="font-bold text-gray-900">{formData.nombre_cliente}</p></div>
          <div><p className="text-[9px] font-black text-gray-400 uppercase">Correo</p><p className="font-bold text-gray-900">{formData.email_cliente}</p></div>
          <div><p className="text-[9px] font-black text-gray-400 uppercase">Teléfono</p><p className="font-bold text-gray-900">{formData.countryCode} {formData.telefono}</p></div>
          <div><p className="text-[9px] font-black text-gray-400 uppercase">Documento</p><p className="font-bold text-gray-900">{formData.tipoId} - {formData.numeroId}</p></div>
        </div>

        <div className="pt-3 border-t border-sky-200/80">
          <p className="text-[10px] font-black text-sky-800 uppercase mb-2">Fechas Solicitadas (Ambas requeridas)</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <div className="bg-white p-3 rounded-2xl border border-sky-100 shadow-sm">
              <span className="text-[9px] font-black text-sky-600 uppercase block">Opción 1</span>
              <span className="text-xs font-bold text-gray-900">{formData.fecha1} a las {formData.hora1}</span>
            </div>
            <div className="bg-white p-3 rounded-2xl border border-sky-100 shadow-sm">
              <span className="text-[9px] font-black text-sky-600 uppercase block">Opción 2</span>
              <span className="text-xs font-bold text-gray-900">{formData.fecha2} a las {formData.hora2}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2.5">
        <button
          onClick={onSubmit}
          disabled={loading}
          className="w-full py-3.5 bg-sky-600 text-white rounded-2xl font-black uppercase text-xs tracking-widest shadow-lg shadow-sky-200 hover:bg-sky-700 active:scale-95 transition-all"
        >
          {loading ? 'Enviando...' : 'Confirmar y Agendar'}
        </button>
        <button
          onClick={onBack}
          type="button"
          className="w-full py-2.5 text-xs font-black uppercase text-gray-400 hover:text-gray-700 transition-colors"
        >
          Volver a editar
        </button>
      </div>
    </div>
  );
};
